const InvoiceStatusEnum = {
    DRAFT: 'DRAFT',
    SENT: 'SENT', 
    PAID: 'PAID',
    CANCELED: 'CANCELED'
  };

export default InvoiceStatusEnum;